<template>
  <van-popup
    v-model="modelValue"
    v-bind="$attrs"
    v-on="$listeners"
    lock-scroll
    get-container="body"
    position="bottom"
    class="transparent__popup"
  >
    <div :class="[isStore && 'isStore', 'popup-wrapper']">
      <div class="line"></div>
      <div class="main-wrapper">
        <div class="vz-flex1" style="overflow: auto; width: 100%">
          <slot></slot>
        </div>
        <div v-if="!hideButtonBar" class="bottom-bar">
          <span @click="$emit('input', false)" class="button">
            {{ cancelText }}
          </span>
          <span
            @click="handleConfirm"
            class="button active"
            :style="storeBgStyle"
          >
            {{ activeText }}
          </span>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'

export default {
  name: 'FilterPanelPopup',
  props: {
    value: {
      default: false,
      type: Boolean,
    },
    currentValue: [Number, String],
    cancelText: {
      type: String,
      default: () => {
        return '取消'
      },
    },
    activeText: {
      type: String,
      default: () => {
        return '筛选'
      },
    },
    hideButtonBar: Boolean,
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    // * 当前是否门店系统客户模块
    isStore() {
      return StoreController.isStore()
    },
    storeBgStyle() {
      return StoreController.btnBgStyle()
    },
    storePlainBgStyle() {
      return StoreController.plainBgStyle()
    },
    storeBorderStyle() {
      return StoreController.borderStyle()
    },
  },
  data() {
    return {}
  },
  watch: {
    modelValue: {
      handler(val) {},
      immediate: true,
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .search input {
    font-size: 14px;
  }
}
.transparent__popup {
  max-height: 80%;
  overflow: auto;
  background: transparent !important;
}
.img-icon {
  width: 100px;
  height: 100px;
}
.popup-wrapper {
  width: 100%;
  height: 100%;
  .line {
    width: 40px;
    height: 4px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    margin: 0 auto 10px;
  }
}
.bottom-bar {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  align-items: center;
  border-top: 1px solid #edeff2;
  gap: 10px;
  .button {
    flex: 1;
    height: 50px;
    background: #f0f7fe;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #006cff;
    line-height: 14px;
    text-align: center;
    border-radius: 25px;
    &.active {
      color: #fff;
      background: linear-gradient(270deg, #00a5ff 0%, #006cff 100%);
    }
  }
}
.isStore {
  .bottom-bar {
    .button {
      color: #919499;
      line-height: 14px;
      text-align: center;
      white-space: nowrap;
      &.active {
        color: var(--primary-color);
      }
    }
  }
}
.main-wrapper {
  position: relative;
  background: #fff;
  padding: 20px 16px 10px;
  border-radius: 18px 18px 0px 0px;
  box-sizing: border-box;
  max-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-size: 10px;
  color: #202124;
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #202124;
    line-height: 16px;
  }
}
.agent-empty {
  margin-top: 24px;
}
</style>
